import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="logo-container">
        <div className="frame"></div>
        <div className="frame-offset"></div>
        <div className="content">
          <div className="house-icon">⌂</div>
          <h1 className="title">NESTOPIA VISION</h1>
        </div>
      </div>

      <section className="hero-section">
        <h2 className="hero-title">Your AI-Powered Interior Designer</h2>
        <div className="coming-soon">Coming Soon</div>
        <p className="hero-description">
          Transform your space with personalized design suggestions tailored to your home. 
        </p>
      </section>

      <section className="about-section">
        <p className="about-text">
          Nestopia Vision is designing a better tomorrow by reimagining how people shop 
          for their homes, creating a more sustainable interior design experience.
        </p>
        <div className="contact">
          <span>Contact</span>
          Minéa Håkans | <a href="mailto:minea@nestopiavision.com">minea@nestopiavision.com</a>
        </div>
      </section>
    </div>
  );
}

export default App;
